import ActionListModal from './ActionListModal.component';

export default ActionListModal;
